module.exports = __webpack_public_path__ + "static/media/battleback4.36285b26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/battleback4.png
// module id = 527
// module chunks = 0